module.exports = __webpack_public_path__ + "static/media/wt_rt_arw.9cba6714.svg";